<template>
  <div class="staff-list-container">
    <el-card class="staff-header-card">
      <div class="header-content">
        <div class="header-left"><h2>员工管理</h2></div>
        <div class="header-right">
          <el-button type="primary" @click="handleAddStaff"><i class="el-icon-plus"></i> 添加员工</el-button>
          <el-button @click="refreshData"><i class="el-icon-refresh"></i> 刷新</el-button>
        </div>
      </div>
    </el-card>

    <el-card class="filter-card">
      <div class="filter-content">
        <el-input v-model="searchKeyword" placeholder="搜索员工姓名/用户名" prefix-icon="el-icon-search" style="width:250px" @keyup.enter.native="handleSearch" clearable @clear="handleClearSearch" />
      </div>
    </el-card>

    <el-card class="staff-table-card">
      <div v-loading="loading">
        <el-table :data="filteredStaffList" style="width:100%" :header-cell-style="{background:'#f5f7fa',color:'#606266'}">
          <el-table-column prop="id" label="员工ID" width="80"/>
          <el-table-column prop="name" label="员工姓名" min-width="150">
            <template slot-scope="{row}">
              <div class="staff-name-cell">
                <el-avatar :size="36" class="staff-avatar">{{ row.name ? row.name.charAt(0) : '员' }}</el-avatar>
                <div class="staff-info">
                  <div class="name">{{ row.name }}</div>
                  <div class="phone">{{ row.phone || '--' }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" width="130"/>
          <el-table-column prop="role" label="角色" width="100">
            <template slot-scope="{row}">
              <el-tag :type="row.role === 2 ? 'warning' : 'info'" size="small">{{ row.role === 2 ? '店长' : '员工' }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100">
            <template slot-scope="{row}">
              <el-tag :type="getStatusType(row.status)" size="small">{{ getStatusText(row.status) }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="250" fixed="right">
            <template slot-scope="{row}">
              <el-button type="text" size="small" @click="handleEdit(row)"><i class="el-icon-edit"></i> 编辑</el-button>
              <el-button type="text" size="small" style="color:#E6A23C" @click="handleResetPassword(row)">重置密码</el-button>
              <el-button type="text" size="small" style="color:#F56C6C" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-container">
          <el-pagination :current-page="pagination.currentPage" :page-sizes="[10,20,50,100]" :page-size="pagination.pageSize" :total="pagination.total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
        </div>
      </div>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="staffDialog.visible" width="500px" :close-on-click-modal="false" :append-to-body="true" modal-append-to-body @closed="handleDialogClosed">
      <el-form :model="staffDialog.form" :rules="staffDialog.rules" ref="staffFormRef" label-width="100px">
        <el-form-item label="员工姓名" prop="name" required>
          <el-input v-model="staffDialog.form.name" placeholder="请输入员工姓名" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="手机号" prop="phone" required>
          <el-input v-model="staffDialog.form.phone" placeholder="请输入手机号（登录账号）" maxlength="20" />
          <div class="form-tip">手机号将作为员工登录账号</div>
        </el-form-item>
      </el-form>

      <div v-if="staffDialog.newPassword" class="password-result">
        <el-alert title="员工添加成功" type="success" :closable="false" show-icon>
          <template slot="title">
            <span>员工添加成功，初始密码：</span>
            <strong class="password-text">{{ staffDialog.newPassword }}</strong>
            <el-button type="text" @click="copyPassword" style="margin-left:10px;"><i class="el-icon-document-copy"></i> 复制</el-button>
          </template>
        </el-alert>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeStaffDialog">取消</el-button>
        <el-button type="primary" @click="handleSaveStaff" :loading="staffDialog.loading">确认保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="重置密码" :visible.sync="resetPwdDialog.visible" width="400px" :append-to-body="true" modal-append-to-body @closed="handleResetPwdDialogClosed">
      <el-alert title="重置密码后，员工将使用新密码登录" type="warning" show-icon :closable="false" style="margin-bottom:16px;" />
      <div class="new-password-display" v-if="resetPwdDialog.newPassword">
        <span>新密码：</span><strong>{{ resetPwdDialog.newPassword }}</strong>
        <el-button type="text" @click="copyResetPassword"><i class="el-icon-document-copy"></i> 复制</el-button>
      </div>
      <span slot="footer"><el-button @click="resetPwdDialog.visible = false">关闭</el-button></span>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/utils/api"

export default {
  name: 'StaffList',
  data() {
    return {
      loading: false, storeId: null, storeName: '加载中...', searchKeyword: '',
      pagination: { currentPage: 1, pageSize: 10, total: 0 },
      staffList: [],
      staffDialog: {
        visible: false, loading: false, mode: 'add', newPassword: '',
        form: { id: null, name: '', phone: '' },
        rules: {
          name: [{ required: true, message: '请输入员工姓名', trigger: 'blur' }, { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }],
          phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }]
        }
      },
      resetPwdDialog: { visible: false, loading: false, staffId: null, staffName: '', newPassword: '' }
    }
  },
  computed: {
    dialogTitle() { return this.staffDialog.mode === 'add' ? '添加员工' : '编辑员工信息' },
    filteredStaffList() {
      if (!this.searchKeyword) return this.staffList
      const k = this.searchKeyword.toLowerCase()
      return this.staffList.filter(item => item.name.toLowerCase().includes(k) || (item.username && item.username.toLowerCase().includes(k)))
    }
  },
  mounted() { this.initData() },
  methods: {
    async initData() { this.loading = true; try { await this.loadStaffList() } catch (e) { this.$message.error('初始化失败') } finally { this.loading = false } },
    async getCurrentAdminInfo() {
      try { const res = await api.login_getAdminInfo(null, {}); const d = res.data || res; if (d.code === '000' && d.data) { this.storeId = d.data.merchantId || null; this.storeName = d.data.name || '我的店铺' } } catch (e) {}
    },
    async loadStaffList() {
      this.loading = true
      try {
        const res = await api.seller_getAdminSellerList({ page: this.pagination.currentPage, pageSize: this.pagination.pageSize }, null)
        const d = res.data || res
        if (d.code === '000' && d.data) {
          const data = d.data
          if (data.list) { this.staffList = data.list || []; this.pagination.total = data.total || 0 }
          else if (Array.isArray(data)) { this.staffList = data; this.pagination.total = data.length }
          else { this.staffList = []; this.pagination.total = 0 }
        }
      } catch (e) { this.$message.error('加载失败') }
      finally { this.loading = false }
    },
    handleSearch() {},
    handleClearSearch() { this.searchKeyword = '' },
    handleAddStaff() {
      this.staffDialog.mode = 'add'; this.staffDialog.newPassword = ''; this.staffDialog.form = { id: null, name: '', phone: '' }
      this.staffDialog.visible = true
      this.$nextTick(() => { this.$refs.staffFormRef && this.$refs.staffFormRef.clearValidate() })
    },
    handleEdit(staff) {
      this.staffDialog.mode = 'edit'; this.staffDialog.newPassword = ''; this.staffDialog.form = { id: staff.id, name: staff.name, phone: staff.phone || '' }
      this.staffDialog.visible = true
      this.$nextTick(() => { this.$refs.staffFormRef && this.$refs.staffFormRef.clearValidate() })
    },
    async handleSaveStaff() {
      if (!this.$refs.staffFormRef) return
      try { await this.$refs.staffFormRef.validate() } catch (e) { return }
      this.staffDialog.loading = true
      try {
        const params = { name: this.staffDialog.form.name, phone: this.staffDialog.form.phone, username: this.staffDialog.form.phone }
        let res
        if (this.staffDialog.mode === 'add') { res = await api.seller_addSeller(params, null) }
        else { params.id = this.staffDialog.form.id; res = await api.seller_editSeller(params, null) }
        const d = res.data || res
        if (d.code === '000') {
          if (this.staffDialog.mode === 'add') this.staffDialog.newPassword = d.data
          this.$message.success(this.staffDialog.mode === 'add' ? '添加成功' : '更新成功')
          this.loadStaffList()
        } else { this.$message.error(d.message || '操作失败') }
      } catch (e) { this.$message.error('操作失败') }
      finally { this.staffDialog.loading = false }
    },
    closeStaffDialog() { this.staffDialog.visible = false; this.staffDialog.newPassword = '' },
    copyPassword() { if (this.staffDialog.newPassword) navigator.clipboard.writeText(this.staffDialog.newPassword).then(() => this.$message.success('已复制')) },
    async handleResetPassword(staff) {
      try { await this.$confirm(`确定重置员工 ${staff.name} 的密码吗？`, '提示', { type: 'warning' }); const res = await api.seller_resetPassword({ id: staff.id }, null); const d = res.data || res; if (d.code === '000') { this.resetPwdDialog = { visible: true, staffId: staff.id, staffName: staff.name, newPassword: d.data } } else this.$message.error(d.message || '重置失败') } catch (e) {}
    },
    copyResetPassword() { if (this.resetPwdDialog.newPassword) navigator.clipboard.writeText(this.resetPwdDialog.newPassword).then(() => this.$message.success('已复制')) },
    async handleDelete(staff) {
      try { await this.$confirm(`确定删除员工 ${staff.name} 吗？`, '警告', { type: 'warning' }); const res = await api.seller_deleteSeller({ id: staff.id }, null); if ((res.data || res).code === '000') { this.$message.success('删除成功'); this.loadStaffList() } else this.$message.error((res.data || res).message || '删除失败') } catch (e) {}
    },
    handleSizeChange(size) { this.pagination.pageSize = size; this.pagination.currentPage = 1; this.loadStaffList() },
    handleCurrentChange(page) { this.pagination.currentPage = page; this.loadStaffList() },
    refreshData() { this.pagination.currentPage = 1; this.searchKeyword = ''; this.loadStaffList() },
    handleDialogClosed() { this.staffDialog.newPassword = ''; this.$refs.staffFormRef && this.$refs.staffFormRef.clearValidate() },
    handleResetPwdDialogClosed() { this.resetPwdDialog = { visible: false, staffId: null, staffName: '', newPassword: '' } },
    getStatusText(s) { return { 1: '在职', 2: '休假', 3: '离职' }[s] || '在职' },
    getStatusType(s) { return { 1: 'success', 2: 'warning', 3: 'danger' }[s] || 'success' }
  }
}
</script>

<style scoped lang="scss">
.staff-list-container { padding: 20px; }
.staff-header-card { margin-bottom: 20px; .header-content { display: flex; justify-content: space-between; align-items: center; } .header-left { h2 { margin: 0 0 8px 0; font-size: 24px; color: #303133; } .store-info { display: flex; align-items: center; gap: 12px; .store-name { font-size: 16px; color: #606266; font-weight: 500; } } } }
.filter-card { margin-bottom: 20px; }
.staff-table-card { .staff-name-cell { display: flex; align-items: center; .staff-avatar { margin-right: 12px; background-color: #409eff; color: white; font-weight: bold; } .staff-info { .name { font-weight: 500; margin-bottom: 4px; } .phone { font-size: 12px; color: #909399; } } } }
.pagination-container { display: flex; justify-content: flex-end; margin-top: 20px; padding-top: 20px; border-top: 1px solid #ebeef5; }
.form-tip { font-size: 12px; color: #909399; margin-top: 4px; }
.password-result { margin-top: 16px; .password-text { font-size: 16px; color: #67c23a; font-family: monospace; margin: 0 4px; } }
.new-password-display { background-color: #f5f7fa; padding: 12px 16px; border-radius: 4px; display: flex; align-items: center; gap: 12px; font-size: 16px; strong { color: #67c23a; font-family: monospace; font-size: 18px; } }
:deep(.el-dialog__wrapper) { z-index: 2000 !important; }
:deep(.el-overlay) { z-index: 1999 !important; }
:deep(.v-modal) { z-index: 1999 !important; }
:deep(.el-dialog) { z-index: 2001 !important; }
@media (max-width: 768px) { .staff-list-container { padding: 12px; } .header-content { flex-direction: column; align-items: flex-start !important; gap: 16px; } }
</style>